import { render, staticRenderFns } from "./OrganizationProjects.vue?vue&type=template&id=4755a72e"
import script from "./OrganizationProjects.vue?vue&type=script&lang=js"
export * from "./OrganizationProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports